<div *ngIf="packagesArr.length > 0" class="porta-sub-inst-seach" id="porta-sub-inst-seach-packages">
  <div class="container-fluid pl-5 pr-5">

    <!-- Carrusel nativo (mismo formato que destination-small). Muestra 3 y avanza de a 1 por click. -->
    <div class="native-carousel position-relative py-5" >

      <p class="pl-3" style="font-family: 'Poppins', sans-serif;font-weight: 600; font-size: 38px;color: black;">Paquetes</p>

      <button type="button" class="carousel-arrow carousel-arrow-left" (click)="carousel.prev()" aria-label="Anterior">
        <i class="bi bi-chevron-left"></i>
      </button>

      <div class="native-carousel-viewport">
        <div class="native-carousel-track"
             [style.width.%]="carousel.trackWidthPercent"
             [style.transform]="'translateX(' + carousel.translatePercent + '%)'"
             [style.transition]="carousel.transitionEnabled ? 'transform 0.7s ease' : 'none'">
          <div class="native-carousel-slide text-center p-3 d-flex flex-column h-100" [style.width.%]="carousel.slideWidthPercent" *ngFor="let slide of carousel.extended" id="image-to-cover-packages">
            <div class="image-position position-relative porta-sub-inst-seach-imag">
              <span class="image-container bd-placeholder-img card-img-top position-relative">
                <img
                        usbLazyLoadImage
                        loading="lazy"
                        [lazyImage]="slide.data.image"
                        class="bd-placeholder-img card-img-top"
                        alt="{{ slide.data.title }}">
                          <div class="placeholder position-absolute"
                                [ngStyle]="{'background-color':clientSettingGlobal?.color_main_1}"
                                role="status"
                                style=" top: 50%; left: 50%; transform: translate(-50%, -50%);">
                          </div>
                <div class="capa" [ngStyle]="{'background':clientSettingGlobal?.color_main_3}"></div>
                <button type="button" class="region-badge" *ngIf="slide.data.regionName" (click)="goToCircuits(slide.data.regionRaw, slide.data.categoriaRaw)">
                  Ver más en {{ slide.data.regionName }}
                </button>
              </span>
              <div class="packages-info">
                <p class="mb-1 text-left pt-4 px-md-3 text-center text-uppercase packages-title" style="font-size: 16px; font-weight: 600; color: black">{{ slide.data.title }}</p>
                <p class="mb-1 text-left mb-6 px-md-3 text-center packages-location" style="font-size: 13px; font-weight: 500; color: black">{{ slide.data.location }}</p>
                <p class="mb-1 text-left mb-6 px-md-3 text-center packages-dates" style="font-size: 13px; font-weight: 500; color: rgb(92, 92, 92)">{{ slide.data.subtitle }}</p>
              </div>
              <hr>
              <p class="pb-5 pl-4 pr-4 description-clamp"
                  [tooltip]="slide.data.descriptionPlain"
                  placement="top">{{ slide.data.descriptionShort }}</p>

            </div>
            <div class="text-center mt-auto">
                <button
                        class="btn rounded-pill m-3"
                        style="color:black; height: 55px;  color: white"
                        [ngStyle]="{'background-color': clientSettingGlobal?.color_main_1}"
                        (click)="downloadPdf(slide.data.archivo)"
                >
                  ver
                </button>
            </div>
          </div>
        </div>
      </div>

      <button type="button" class="carousel-arrow carousel-arrow-right" (click)="carousel.next()" aria-label="Siguiente">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

  </div>
</div>
